const CreateTicket = () =>
  import(
    /* webpackChunkName: "TicketViews" */ '../views/ticket/CreateTicket.vue'
    );
const EditTicket = () =>
  import(
    /* webpackChunkName: "TicketViews" */ '../views/ticket/EditTicket.vue'
    );
const TicketDetails = () =>
  import(
    /* webpackChunkName: "TicketViews" */ '../views/ticket/TicketDetails.vue'
    );
const TicketThanks = () =>
  import(
    /* webpackChunkName: "TicketViews" */ '../views/ticket/TicketThanks.vue'
    );
const TicketOverview = () =>
  import(
    /* webpackChunkName: "TicketViews" */ '../views/ticket/TicketOverview.vue'
    );

export const routeTickets = [
  {
    path: 'create-ticket',
    name: 'CreateTicket',
    component: CreateTicket,
    meta: {
      title: 'New Idea'
    }
  },
  {
    path: 'edit-ticket/:id',
    name: 'EditTicket',
    component: EditTicket,
    meta: {
      title: 'Edit Idea'
    }
  },
  {
    path: 'ticket/:id',
    name: 'TicketDetails',
    component: TicketDetails
  },
  {
    path: 'ticket/:id/thank-you',
    name: 'TicketThanks',
    component: TicketThanks,
    meta: {
      title: 'Thank you!'
    }
  },
  {
    path: 'tickets',
    name: 'TicketOverview',
    component: TicketOverview,
    meta: {
      title: 'Ideas'
    }
  }
];
